import { CustomMeasure } from '@counsel-project/counsel-audit-backend-api'
import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import { useState } from 'react'
import AddMeasurementDialog from './AddMeasurementDialog'
import MeasureItem from './MeasureItem'

export type MeasureTableProps = {
  rows: CustomMeasure[]
  onChange: (measurements: CustomMeasure[]) => void
}

export default function MeasureTable({ rows, onChange }: MeasureTableProps) {
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleDelete = (id: string) => {
    onChange(rows.filter((row) => row.id !== id))
  }

  const handleAdd = (measurement: CustomMeasure) => {
    onChange([...rows, measurement])
  }

  const handleChange = (measurement: CustomMeasure) => {
    onChange(rows.map((row) => (row.id === measurement.id ? measurement : row)))
  }

  return (
    <Paper variant="outlined" sx={{ pb: 2 }}>
      {rows.map((row, index) => (
        <MeasureItem
          key={row.id}
          measure={row}
          onChange={handleChange}
          onDelete={() => handleDelete(row.id)}
          isFirst={index === 0}
        />
      ))}

      <Box
        sx={{
          px: 2,
          pt: 2,
          borderTop: rows.length > 0 ? '1px solid' : 'none',
          borderColor: 'divider',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setDialogOpen(true)}
          sx={{ py: 0.7 }}
          data-qa-id="config-add-measurement-button"
        >
          Add Measurement
        </Button>
      </Box>

      <AddMeasurementDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onAdd={handleAdd}
      />
    </Paper>
  )
}
